const {store, AoflElement, clickTrackerMixin, abcmouseTrackerQueue} = aofljs;
import orangeCloseButtonSvg from '../../images/svg/close_btn_orange.svg';
import freeSvg from '../../images/svg/free_popup.svg';
import mouseSvg from '../../images/svg/mouse_svg.svg';
import mouseSvgMobile from '../../images/svg/mouse_svg_mobile.svg';
/**
 * @summary WiaProspectPopup
 * @class WiaProspectPopup
 * @extends {AoflElement}
 */
class WiaProspectPopup extends clickTrackerMixin(AoflElement) {
  /**
   * Creates an instance of WiaProspectPopup.
   * @memberof WiaProspectPopup
   */
  constructor() {
    super(store);
    this.isAndroid = navigator.userAgent.match(/Android/i);
    this.orangeCloseButtonSvg = orangeCloseButtonSvg;
    this.freeSvg = freeSvg;
    this.mouseSvg = mouseSvg;
    this.mouseSvgMobile = mouseSvgMobile;
    this.unsubscribeStore = store.subscribe(() => this.mapProperties());
    this.mapProperties();
  }

  /**
   *
   * @readonly
   * @static
   * @memberof WiaProspectPopup
   */
  static get is() {
    return 'wia-prospect-popup';
  }

  /**
   *
   * @memberof WiaProspectPopup
   */
  connectedCallback() {
    super.connectedCallback();
    abcmouseTrackerQueue.enqueueEvent({
      url: this.pageInfo.pageLoadUrl,
      page_info_key: this.pageInfo.page_info_key
    });
  }

  /**
   *
   * @readonly
   * @static
   * @memberof WiaProspectPopup
   */
  static get properties() {
    return {
      pageInfo: {
        type: Object,
        value: {
          pageLoadUrl: 'homepage/thank_you_for_watching_our_video_pop',
          page_info_key: 'homepage/thank_you_for_watching_our_video_pop'
        }
      }
    };
  }

  /**
   *
   *
   * @memberof WiaProspectPopup
   */
  mapProperties() {
    let state = store.getState().prospectRegForm;
    this.showForm = !state.elog;
  }

  /**
   *
   *
   * @memberof WiaProspectPopup
   */
  handleClose() {
    // This is a temp function to fix the bug for nested components not getting picked up by the click tracker.
    // TODO: Fix when Arian gets back 5/16/18
    abcmouseTrackerQueue.enqueueEvent({
      url: '@linkClick',
      kvp: {
        linkName: 'non-member homepage:thank you for watching our video popup:learn more:close'
      }
    });
    store.commit([
      {
        stateAlias: 'modals',
        mutationId: 'hideModal',
        payload: 'wiaProspect'
      }
    ]);
  }

  /**
   *
   *
   * @memberof WiaProspectPopup
   */
  disconnectedCallback() {
    super.disconnectedCallback();
    this.unsubscribeStore();
  }
}

window.customElements.define(WiaProspectPopup.is, WiaProspectPopup);

export default WiaProspectPopup;



// WEBPACK FOOTER //
// ./home/en-US/js/wia-prospect-popup/wia-prospect-popup.js